<template lang="pug">
.section
  .section-header
    template(v-if="!isDetail && !isMember")
      h1 {{ $t("ui.rebate_summary") }}
    template(v-else)
      template(v-if="isDetail")
        template(v-if="isOperator")
          h1 {{ $t("ui.rebate_summary_daily") }}
        template(v-else)
          .section-header-back
            a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect()")
              i.fas.fa-arrow-left
          h1 {{ $t("ui.rebate_summary_daily") }}
          .section-header-breadcrumb
            .breadcrumb-item
              a(href="javascript:void(0)" @click="redirect()") {{ $t("ui.rebate_summary") }}
            .breadcrumb-item.active
              span {{ $t('ui.rebate_summary_daily') }}
      template(v-else)
        template(v-if="isOperator")
          .section-header-back
            a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect1()")
              i.fas.fa-arrow-left
          h1 {{ $t("ui.rebate_member") }}
          .section-header-breadcrumb
            .breadcrumb-item
              a(href="javascript:void(0)" @click="redirect1()") {{ $t('ui.rebate_summary_daily') }}
            .breadcrumb-item.active
              span {{ $t('ui.rebate_member') }}
        template(v-else)
          .section-header-back
            a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect1()")
              i.fas.fa-arrow-left
          h1 {{ $t("ui.rebate_member") }}
          .section-header-breadcrumb
            .breadcrumb-item
              a(href="javascript:void(0)" @click="redirect()") {{ $t("ui.rebate_summary") }}
            .breadcrumb-item
              a(href="javascript:void(0)" @click="redirect1()") {{ $t('ui.rebate_summary_daily') }}
            .breadcrumb-item.active
              span {{ $t('ui.rebate_member') }}
  .section-body
    .row
      .col-12
        .card.mb-0
          template(v-if="!isDetail && !isMember")
            .card-header
              .row.w-100              
                .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1(v-if="!isOperator")
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-user
                    DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_operator')" @enter="getListSummary(true)" size="sm")
                .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.type') }}
                    b-form-select(v-model="rebate_type" @change="getListSummary(true)" size="sm")
                      option(value="") {{ $t('ui.all') }}
                      option(value="DOWNLINE") {{ $t('ui.downline') }}
                      option(value="SELF") {{ $t("ui.self") }}
                .form-group.col-md-12.col-lg-12.col-xl-6.col-12.mb-1
                  DateRangePicker(:value="dateRange" @update="getData")
                .form-group.col-12.mb-1
                  SubmitButton(
                    icon="fa fa-search"
                    :loading="loading"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getListSummary(true)"
                    variant="primary"
                    size="sm"
                  ).mr-2
                  jsonToExcel(v-if="rebateSummary.length > 0" mode="RebateSummary" tbl="tblSummary" :date="dateRange" btnTxt="export_one" type="0" :loading2="loading2").mr-2
                  jsonToExcelFull(v-if="rebateSummaryFull.length > 0 && $helpers.showExportAll(dateRange) == true" mode="RebateSummary" tbl="tblSummaryFull" :date="dateRange" btnTxt="export_all" type="0" :loading2="loading2")
                  rebateSummaryExport(v-if="rebateSummary.length > 0" :tbl="rebateSummary" tblId="tblSummary" :totalTbl="grandTotalListSummary")
                  rebateSummaryExportFull(v-if="rebateSummaryFull.length > 0 && $helpers.showExportAll(dateRange) == true" :tbl="rebateSummaryFull" tblId="tblSummaryFull" :totalTbl="grandTotalListSummaryFull")
            .card-body
              .row
                .col-10.mb-1
                  b-pagination.float-left(
                    size="sm"
                    hide-ellipsis
                    :total-rows="totalRow"
                    :per-page="getPageSize"
                    v-model="currentPage"
                    @input="changedPage($event)")
                .col-2.mb-1
                  b-input-group(:prepend="$t('ui.page_size')" size="sm")
                    b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
                .col-12
                  .clusterize-scroll.table-responsive
                    table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                      thead.thead-light
                        tr
                          th.text-center(width="5%")
                            span #
                          th(width="35%" @click="sortOrder('account_id')")
                            span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                            .float-right
                              i(:class="changeSortKey('account_id')")
                          th.text-right(width="20%" @click="sortOrder('turnover')")
                            span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                            .float-right
                              i(:class="changeSortKey('turnover')")
                          th.text-right(width="20%" @click="sortOrder('actual_rebate')")
                            span(:title="$t('ui.actual_rebate')") {{ $t('ui.actual_rebate') }}
                            .float-right
                              i(:class="changeSortKey('actual_rebate')")
                          th.text-right(width="20%" @click="sortOrder('rounded_rebate')")
                            span(:title="$t('ui.rounded_rebate')") {{ $t('ui.rounded_rebate') }}
                            .float-right
                              i(:class="changeSortKey('rounded_rebate')")
                      tbody.clusterize-content
                        tr(v-if="rebateSummary.length == 0")
                          td(:colspan="5").text-center
                            span {{ $t('message.no_data_available') }}
                        tr(v-for="(item, index) in rebateSummary")
                          td.text-center
                            span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                          td
                            span(:title="item.operator_id") 
                              b-link(href="javascript:void(0);" @click="drillIn(item.operator_id)") {{ item.operator_id }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.turnover, 'currency')" :class="$helpers.fontClassName(item.turnover)") {{ item.turnover != null ? $n(item.turnover, 'currency') : null }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.actual_rebate, 'currency')" :class="$helpers.fontClassName(item.actual_rebate)") {{ item.actual_rebate != null ? $n(item.actual_rebate, 'currency') : null }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.rounded_rebate, 'currency')" :class="$helpers.fontClassName(item.rounded_rebate)") {{ item.rounded_rebate != null ? $n(item.rounded_rebate, 'currency') : null }}
                          tr(v-if="showTotal")
                            td.text-right(colspan="2")
                              span.d-block {{ $t("ui.sub_total") }}
                              span {{ $t("ui.grand_total") }}
                            td.text-right
                              span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalTurnover)" :title="$n(subTotalTurnover, 'currency')") {{ $n(subTotalTurnover, 'currency') }}
                              span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
                            td.text-right
                              span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalActualRebate)" :title="$n(subTotalActualRebate, 'currency')") {{ $n(subTotalActualRebate, 'currency') }}
                              span.font-weight-bold(:class="$helpers.fontClassName(grandTotallActualRebate)" :title="$n(grandTotallActualRebate, 'currency')") {{ $n(grandTotallActualRebate, 'currency') }}
                            td.text-right
                              span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotallRoundedRebate)" :title="$n(subTotallRoundedRebate, 'currency')") {{ $n(subTotallRoundedRebate, 'currency') }}
                              span.font-weight-bold(:class="$helpers.fontClassName(grandTotalRoundedRebate)" :title="$n(grandTotalRoundedRebate, 'currency')") {{ $n(grandTotalRoundedRebate, 'currency') }}
          template(v-else)
            template(v-if="isDetail")
              .card-header
                .row.w-100              
                  .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        span {{ $t('ui.type') }}
                      b-form-select(v-model="rebate_type" @change="getListSummaryDaily(true)" size="sm")
                        option(value="") {{ $t('ui.all') }}
                        option(value="DOWNLINE") {{ $t('ui.downline') }}
                        option(value="SELF") {{ $t("ui.self") }}
                  .form-group.col-md-12.col-lg-12.col-xl-6.col-12.mb-1
                    DateRangePicker(:value="dateRange1" @update="getData1")
                  .form-group.col-12.mb-1
                    SubmitButton(
                      icon="fa fa-search"
                      :loading="loading"
                      :text="$t('ui.search')"
                      type="button"
                      @click="getListSummaryDaily(true)"
                      variant="primary"
                      size="sm"
                    ).mr-2
                    jsonToExcel(v-if="rebateSummaryDetail.length > 0" mode="RebateSummaryDaily" tbl="tblSummaryDetail" :date="dateRange" btnTxt="export_one" type="0" :loading2="loading2").mr-2
                    jsonToExcelFull(v-if="rebateSummaryDetailFull.length > 0 && $helpers.showExportAll(dateRange) == true" mode="RebateSummaryDaily" tbl="tblSummaryDetailFull" :date="dateRange" btnTxt="export_all" type="0" :loading2="loading2")
                    rebateSummaryDailyExport(v-if="rebateSummaryDetail.length > 0" :tbl="rebateSummaryDetail" tblId="tblSummaryDetail" :totalTbl="grandTotalListSummaryDetail")
                    rebateSummaryDailyExportFull(v-if="rebateSummaryDetailFull.length > 0 && $helpers.showExportAll(dateRange) == true" :tbl="rebateSummaryDetailFull" tblId="tblSummaryDetailFull" :totalTbl="grandTotalListSummaryDetailFull")
              .card-body
                .row
                  .col-12.mb-1
                    h2.section-title.mt-0 {{ selectedOperatorID }}
                  .col-10.mb-1
                    b-pagination.float-left(
                      size="sm"
                      hide-ellipsis
                      :total-rows="totalRow1"
                      :per-page="getPageSize"
                      v-model="currentPage1"
                      @input="changedPage1($event)")
                  .col-2.mb-1
                    b-input-group(:prepend="$t('ui.page_size')" size="sm")
                      b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize1" size="sm")
                  .col-12
                    .clusterize-scroll.table-responsive
                      table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
                        thead.thead-light
                          tr
                            th.text-center(width="5%")
                              span #
                            th(width="35%" @click="sortOrder1('working_date')")
                              span(:title="$t('ui.working_date')") {{ $t('ui.working_date') }}
                              .float-right
                                i(:class="changeSortKey1('working_date')")
                            th.text-right(width="20%" @click="sortOrder1('turnover')")
                              span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                              .float-right
                                i(:class="changeSortKey1('turnover')")
                            th.text-right(width="20%" @click="sortOrder1('actual_rebate')")
                              span(:title="$t('ui.actual_rebate')") {{ $t('ui.actual_rebate') }}
                              .float-right
                                i(:class="changeSortKey1('workinactual_rebateg_date')")
                            th.text-right(width="20%" @click="sortOrder1('rounded_rebate')")
                              span(:title="$t('ui.rounded_rebate')") {{ $t('ui.rounded_rebate') }}
                              .float-right
                                i(:class="changeSortKey1('rounded_rebate')")
                        tbody.clusterize-content
                          tr(v-if="rebateSummaryDetail.length == 0")
                            td(:colspan="5").text-center
                              span {{ $t('message.no_data_available') }}
                          tr(v-for="(item, index) in rebateSummaryDetail")
                            td.text-center
                              span(:title="((currentPage1 - 1) * getPageSize + index + 1)") {{ ((currentPage1 - 1) * getPageSize + index + 1) }}
                            td
                              span(:title="$moment(item.working_date).format('YYYY-MM-DD')") 
                                b-link(href="javascript:void(0);" @click="drillIn1(item.working_date)") {{ $moment(item.working_date).format('YYYY-MM-DD') }}
                            td.text-right
                              span.font-weight-bold(:title="$n(item.turnover, 'currency')" :class="$helpers.fontClassName(item.turnover)") {{ item.turnover != null ? $n(item.turnover, 'currency') : null }}
                            td.text-right
                              span.font-weight-bold(:title="$n(item.actual_rebate, 'currency')" :class="$helpers.fontClassName(item.actual_rebate)") {{ item.actual_rebate != null ? $n(item.actual_rebate, 'currency') : null }}
                            td.text-right
                              span.font-weight-bold(:title="$n(item.rounded_rebate, 'currency')" :class="$helpers.fontClassName(item.rounded_rebate)") {{ item.rounded_rebate != null ? $n(item.rounded_rebate, 'currency') : null }}
                            tr(v-if="showTotal1")
                              td.text-right(colspan="2")
                                span.d-block {{ $t("ui.sub_total") }}
                                span {{ $t("ui.grand_total") }}
                              td.text-right
                                span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalTurnover1)" :title="$n(subTotalTurnover1, 'currency')") {{ $n(subTotalTurnover1, 'currency') }}
                                span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover1)" :title="$n(grandTotalTurnover1, 'currency')") {{ $n(grandTotalTurnover1, 'currency') }}
                              td.text-right
                                span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalActualRebate1)" :title="$n(subTotalActualRebate1, 'currency')") {{ $n(subTotalActualRebate1, 'currency') }}
                                span.font-weight-bold(:class="$helpers.fontClassName(grandTotallActualRebate1)" :title="$n(grandTotallActualRebate1, 'currency')") {{ $n(grandTotallActualRebate1, 'currency') }}
                              td.text-right
                                span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotallRoundedRebate1)" :title="$n(subTotallRoundedRebate1, 'currency')") {{ $n(subTotallRoundedRebate1, 'currency') }}
                                span.font-weight-bold(:class="$helpers.fontClassName(grandTotalRoundedRebate1)" :title="$n(grandTotalRoundedRebate1, 'currency')") {{ $n(grandTotalRoundedRebate1, 'currency') }}
            template(v-if="isMember")
              .card-header
                .row.w-100
                  //- .form-group.col-md-12.col-lg-12.col-xl-6.col-12.mb-1
                  //-   DateRangePicker(:value="dateRange2" @update="getData2")
                  .form-group.col-12.mb-1
                    SubmitButton(
                      icon="fa fa-sync"
                      :loading="loading"
                      :text="$t('ui.refresh')"
                      type="button"
                      @click="getListMember(true)"
                      variant="primary"
                      size="sm"
                    ).mr-2
                    jsonToExcel(v-if="rebateMember.length > 0" mode="RebateMember" tbl="tblMember" :date="dateRange" btnTxt="export_one" type="0" :loading2="loading2").mr-2
                    jsonToExcelFull(v-if="rebateMemberFull.length > 0 && $helpers.showExportAll(dateRange) == true" mode="RebateMember" tbl="tblMemberFull" :date="dateRange" btnTxt="export_all" type="0" :loading2="loading2")
                    rebateMemberExport(v-if="rebateMember.length > 0" :tbl="rebateMember" tblId="tblMember")
                    rebateMemberExportFull(v-if="rebateMemberFull.length > 0 && $helpers.showExportAll(dateRange) == true" :tbl="rebateMemberFull" tblId="tblMemberFull")
              .card-body
                .row
                  .col-12.mb-1
                    h2.section-title.mt-0 {{ selectedOperatorID }}
                  .col-10.mb-1
                    b-pagination.float-left(
                      size="sm"
                      hide-ellipsis
                      :total-rows="totalRow2"
                      :per-page="getPageSize"
                      v-model="currentPage2"
                      @input="changedPage2($event)")
                  .col-2.mb-1
                    b-input-group(:prepend="$t('ui.page_size')" size="sm")
                      b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize2" size="sm")
                  .col-12
                    .clusterize-scroll.table-responsive
                      table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
                        thead.thead-light
                          tr
                            th.text-center(width="3%")
                              span #
                            th.text-left(width="10%" @click="sortOrder2('account_id')")
                              span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                              .float-right
                                i(:class="changeSortKey2('account_id')")
                            th.text-left(width="7%")
                              span(:title="$t('ui.inbox_id')") {{ $t('ui.inbox_id') }}
                            th.text-left(width="7%")
                              span(:title="$t('ui.vip_name')") {{ $t('ui.vip') }}
                            th.text-left(width="10%" @click="sortOrder2('rebate_mode')")
                              span(:title="$t('ui.rebate_mode')") {{ $t('ui.rebate_mode') }}
                              .float-right
                                i(:class="changeSortKey2('rebate_mode')")
                            th.text-right(width="7%" @click="sortOrder2('rebate_rate')")
                              span(:title="$t('ui.rebate_rate')") {{ $t('ui.rebate_rate') }}
                              .float-right
                                i(:class="changeSortKey2('rebate_rate')")
                            th.text-center(width="7%" @click="sortOrder2('rebate_type')")
                              span(:title="$t('ui.rebate_type')") {{ $t('ui.rebate_type') }}
                              .float-right
                                i(:class="changeSortKey2('rebate_type')")
                            th.text-right(width="10%" @click="sortOrder2('total_turnover')")
                              span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                              .float-right
                                i(:class="changeSortKey2('total_turnover')")
                            th.text-right(width="10%" @click="sortOrder2('turnover_tier')")
                              span(:title="$t('ui.turnover_tier')") {{ $t('ui.turnover_tier') }}
                              .float-right
                                i(:class="changeSortKey2('turnover_tier')")
                            th.text-right(width="10%" @click="sortOrder2('actual_rebate')")
                              span(:title="$t('ui.actual_rebate')") {{ $t('ui.actual_rebate') }}
                              .float-right
                                i(:class="changeSortKey2('actual_rebate')")
                            th.text-right(width="10%" @click="sortOrder2('rounded_rebate')")
                              span(:title="$t('ui.rounded_rebate')") {{ $t('ui.rounded_rebate') }}
                              .float-right
                                i(:class="changeSortKey2('rounded_rebate')")
                            th.text-right(width="16%" @click="sortOrder2('action_date')")
                              span(:title="$t('ui.action_date')") {{ $t('ui.action_date') }}
                              .float-right
                                i(:class="changeSortKey2('action_date')")
                        tbody.clusterize-content
                          tr(v-if="rebateMember.length == 0")
                            td(:colspan="12").text-center
                              span {{ $t('message.no_data_available') }}
                          template(v-for="(item, index) in rebateMember")
                            tr
                              td.text-center
                                span(:title="((currentPage2 - 1) * getPageSize + index + 1)") {{ ((currentPage2 - 1) * getPageSize + index + 1) }}
                              td.text-left
                                span(:title="item.account_id") {{ item.account_id }}
                              td.text-left
                                span(:title="item.inbox_id") {{ item.inbox_id }}
                              td.text-left
                                span(:title="item.vip_name")
                                  i.fas.fa-crown(v-if="item.vip_name") &nbsp;{{ item.vip_name }}
                              td.text-left
                                span(:title="item.rebate_mode") {{ item.rebate_mode }}
                                template(v-if="item.rebate_mode == 'VIP TIER'")
                                  i.fa.ml-1(:title="$t('ui.detail')" size="sm" @click="onOffDetail(item)" :class="currId == item.id ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                              td.text-right
                                span(:title="item.rebate_rate") {{ item.rebate_rate }}
                              td.text-center
                                span(:title="item.rebate_type") {{ item.rebate_type }}
                              td.text-right
                                span.font-weight-bold(:class="$helpers.fontClassName(item.total_turnover)" :title="$n(item.total_turnover, 'currency')") {{ item.total_turnover != null ? $n(item.total_turnover, 'currency') : null }}
                              td.text-right
                                span.font-weight-bold(:class="$helpers.fontClassName(item.turnover_tier)" :title="$n(item.turnover_tier, 'currency')") {{ item.turnover_tier != null ? $n(item.turnover_tier, 'currency') : null }}
                              td.text-right
                                span.font-weight-bold(:class="$helpers.fontClassName(item.actual_rebate)" :title="$n(item.actual_rebate, 'currency')") {{ item.actual_rebate != null ? $n(item.actual_rebate, 'currency') : null }}
                              td.text-right
                                span.font-weight-bold(:class="$helpers.fontClassName(item.rounded_rebate)" :title="$n(item.rounded_rebate, 'currency')") {{ item.rounded_rebate != null ? $n(item.rounded_rebate, 'currency') : null }}
                              td.text-right
                                span(:title="$moment(item.action_date).format('YYYY-MM-DD HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD HH:mm:ss') }}
                            tr.text-center(v-if="isShowDetail == true && currId == item.id")
                              td(colspan="12")
                                table.table.table-sm.table-bordered.table-striped.table-hover(style="width: 50%;").mb-2.m-auto
                                  thead.thead-dark
                                    tr
                                      th.text-left(width="25%")
                                        span {{ $t("ui.provider_code") }}
                                      th.text-right(width="25%")
                                        span {{ $t("ui.turnover") }}
                                      th.text-right(width="25%")
                                        span {{ $t("ui.rebate_rate") }}
                                      th.text-right(width="25%")
                                        span {{ $t("ui.actual_rebate") }}
                                  tbody.clusterize-content
                                    template(v-if="rebateProvider.length == 0")
                                      td(:colspan="12").text-center
                                        span {{ $t('message.no_data_available') }}
                                    template(v-for="(item1, index1) in rebateProvider")
                                      tr
                                        td.text-left
                                          span(:title="item1.provider_code") {{ item1.provider_code }}
                                        td.text-right
                                          span.font-weight-bold(:class="$helpers.fontClassName(item1.turnover)" :title="$n(item1.turnover, 'currency')") {{ item1.turnover != null ? $n(item1.turnover, 'currency') : null }}
                                        td.text-right
                                          span.font-weight-bold(:class="$helpers.fontClassName(item.rebate_rate)" :title="item1.rebate_rate") {{ item1.rebate_rate }}
                                        td.text-right
                                          span.font-weight-bold(:class="$helpers.fontClassName(item.actual_rebate)" :title="$n(item1.actual_rebate, 'currency')") {{ item1.actual_rebate != null ? $n(item1.actual_rebate, 'currency') : null }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import jsonToExcelFull from "@/library/jsonToExcelFull.vue";
import rebateSummaryExport from "@/components/report/rebateSummaryExportFull.vue";
import rebateSummaryExportFull from "@/components/report/rebateSummaryExportFull.vue";
import rebateSummaryDailyExport from "@/components/report/rebateSummaryDailyExportFull.vue";
import rebateSummaryDailyExportFull from "@/components/report/rebateSummaryDailyExportFull.vue";
import rebateMemberExport from "@/components/report/rebateMemberExportFull.vue";
import rebateMemberExportFull from "@/components/report/rebateMemberExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    jsonToExcelFull,
    rebateSummaryExport,
    rebateSummaryExportFull,
    rebateSummaryDailyExport,
    rebateSummaryDailyExportFull,
    rebateMemberExport,
    rebateMemberExportFull
  },
  data: () => ({
    loading: false,
    loading2: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null,
    },
    dateRange1: {
      startDate: null,
      endDate: null,
    },
    dateRange2: {
      startDate: null,
      endDate: null,
    },
    searchID: "",    
    rebate_type: "",
    currId: null,
    isDetail: false,
    isMember: false,
    selectedOperatorID: "",
    rebateSummary: [],
    rebateSummaryFull: [],
    rebateSummaryDetail: [],
    rebateSummaryDetailFull: [],
    rebateMember: [],
    rebateMemberFull: [],
    rebateProvider: [],
    currentPage: 1,
    totalRow: 0,
    sortKey: "account_id",
    sortType: "asc",
    currentPage1: 1,
    totalRow1: 0,
    sortKey1: "working_date",
    sortType1: "asc",
    currentPage2: 1,
    totalRow2: 0,
    sortKey2: "working_date",
    sortType2: "asc",
    isShowDetail: false,
    showTotal: false,
    showTotal1: false,
    showTotal2: false,
    subTotalTurnover: 0,
    grandTotalTurnover: 0,
    subTotalActualRebate: 0,
    grandTotallActualRebate: 0,
    subTotallRoundedRebate: 0,
    grandTotalRoundedRebate: 0,
    subTotalTurnover1: 0,
    grandTotalTurnover1: 0,
    subTotalActualRebate1: 0,
    grandTotallActualRebate1: 0,
    subTotallRoundedRebate1: 0,
    grandTotalRoundedRebate1: 0,
    grandTotalListSummary: [],
    grandTotalListSummaryFull: [],
    grandTotalListSummaryDetail: [],
    grandTotalListSummaryDetailFull: []
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },  
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
    if(this.$store.getters.sessionToken) {
      if(this.isOperator) {
        this.isDetail = true
        this.$nextTick(() => {
          this.dateRange1.startDate = this.$moment(new Date).format('YYYY-MM-DD');
          this.dateRange1.endDate = this.$moment(new Date).format('YYYY-MM-DD');
          this.selectedOperatorID = this.accountID;
          this.getListSummaryDaily(true);
        });        
      } else {
        // this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        // this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        if (this.$store.getters.reportStatement.operator_id != null)
          this.searchID = this.$store.getters.reportStatement.operator_id;

        if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
          this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
          this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
        }
        this.getListSummary(true);
      }
    }
  },
  methods: {
    onOffDetail(item) {
      if (this.isShowDetail == true) {
        if (this.currId == item.id) {
          this.isShowDetail = false;
          this.currId = null;
        } else {
          this.isShowDetail = true;
          this.currId = item.id;
          this.getRebateProvider(item.id)
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.id;
        this.getRebateProvider(item.id)
      }
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getRebateSummary(true);

    },
    sortOrder1(key) {
      if (this.sortKey1 == key)
        this.sortType1 = this.sortType1 == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey1 = key;
        this.sortType1 = 'asc';
      }
      this.getRebateSummaryDaily(true);

    },
    sortOrder2(key) {
      if (this.sortKey2 == key)
        this.sortType2 = this.sortType2 == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey2 = key;
        this.sortType2 = 'asc';
      }
      this.getRebateMember(true);

    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    changeSortKey1(key) {
      if (this.sortKey1 != key)
        return 'fas fa-sort';
      else if (this.sortKey1 == key && this.sortType1 == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey1 == key && this.sortType1 == 'desc')
        return 'fa fa-sort-down';
    },
    changeSortKey2(key) {
      if (this.sortKey2 != key)
        return 'fas fa-sort';
      else if (this.sortKey2 == key && this.sortType2 == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey2 == key && this.sortType2 == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    redirect() {
      this.isDetail = false;
      this.isMember = false;
      // this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      // this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getListSummary(true);
    },
    redirect1() {
      this.isDetail = true;
      this.isMember = false;
      // this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      // this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getListSummaryDaily(true);
    },
    getListSummary(isSearch) {
      if (this.checkDateRange()) {
        this.getRebateSummary(isSearch);
        if (this.$helpers.showExportAll(this.dateRange) == true) {
          this.getRebateSummaryFull(isSearch);
        }
      } else {
        this.clearRebateSummary();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getListSummaryDaily(isSearch) {
      if (this.checkDateRange()) {
        this.getRebateSummaryDaily(isSearch);
        if (this.$helpers.showExportAll(this.dateRange) == true) {
          this.getRebateSummaryDailyFull(isSearch);
        }
      } else {
        this.clearRebateSummaryDetail();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getListMember(isSearch) {
      if (this.checkDateRange()) {
        this.getRebateMember(isSearch);
        if (this.$helpers.showExportAll(this.dateRange) == true) {
          this.getRebateMemberFull(isSearch);
        }
      } else {
        this.clearRebateMember();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getListSummary(true);
    },
    getData1(currentValue) {
      this.dateRange1.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange1.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getListSummaryDaily(true);
    },
    getData2(currentValue) {
      this.dateRange2.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange2.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getListMember(true);
    },
    setReportStatementParam: function() {
      var json = {
        operator_id: this.searchID,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };
      this.$store.dispatch("user/setReportStatementParam", json);
    },
    getRebateSummary: function(isSearch) {
      this.isDetail = false
      this.isMember = false
      if (this.checkDateRange()) {
        this.setReportStatementParam();
        let url = config.rebateSummaryUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          rebate_type: this.rebate_type == "" ? null : this.rebate_type,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearRebateSummary()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.list.length > 0) {
                    this.showTotal = true
                    response.data.ds.list.forEach(value => {
                      this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
                      this.subTotalActualRebate = parseFloat(this.subTotalActualRebate) + parseFloat(value["actual_rebate"]);
                      this.subTotallRoundedRebate = parseFloat(this.subTotallRoundedRebate) + parseFloat(value["rounded_rebate"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnover = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotallActualRebate = response.data.ds.grand_total[0]["actual_rebate"];
                      this.grandTotalRoundedRebate = response.data.ds.grand_total[0]["rounded_rebate"];
                    }
                    this.grandTotalListSummary = response.data.ds.grand_total;
                    this.rebateSummary = response.data.ds.list;
                    this.totalRow = this.rebateSummary.length > 0 ? this.rebateSummary[0].totalrows : 0;
                  } else {
                    this.clearRebateSummary()
                  }
                } else {
                  this.clearRebateSummary()
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.clearRebateSummary();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getRebateSummaryFull: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.rebateSummaryUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          rebate_type: this.rebate_type == "" ? null : this.rebate_type,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.grandTotalListSummaryFull = response.data.ds.grand_total;
                  this.rebateSummaryFull = response.data.ds.list;
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
    },
    drillIn(id) {
      this.isDetail = true
      this.dateRange1.startDate = this.dateRange.startDate;
      this.dateRange1.endDate = this.dateRange.endDate;
      this.selectedOperatorID = id;

      this.getListSummaryDaily();
    },
    drillIn1(date) {
      this.isDetail = false
      this.isMember = true
      this.dateRange2.startDate = date;
      this.dateRange2.endDate = date;

      this.getListMember();
    },
    getRebateSummaryDaily: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.rebateSummaryDailyUrl();

        if (isSearch) this.currentPage1 = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.selectedOperatorID,
          start_date: this.dateRange1.startDate,
          end_date: this.dateRange1.endDate,
          rebate_type: this.rebate_type == "" ? null : this.rebate_type,
          sort_key: this.sortKey1,
          sort_type: this.sortType1,
          page_number: this.currentPage1,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearRebateSummaryDetail()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.list.length > 0) {
                    this.showTotal1 = true
                    response.data.ds.list.forEach(value => {
                      this.subTotalTurnover1 = parseFloat(this.subTotalTurnover1) + parseFloat(value["turnover"]);
                      this.subTotalActualRebate1 = parseFloat(this.subTotalActualRebate1) + parseFloat(value["actual_rebate"]);
                      this.subTotallRoundedRebate1 = parseFloat(this.subTotallRoundedRebate1) + parseFloat(value["rounded_rebate"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnover1 = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotallActualRebate1 = response.data.ds.grand_total[0]["actual_rebate"];
                      this.grandTotalRoundedRebate1 = response.data.ds.grand_total[0]["rounded_rebate"];
                    }

                    this.grandTotalListSummaryDetail = response.data.ds.grand_total;
                    this.rebateSummaryDetail = response.data.ds.list;
                    this.totalRow1 = this.rebateSummaryDetail.length > 0 ? this.rebateSummaryDetail[0].totalrows : 0;
                  } else {
                    this.clearRebateSummaryDetail()
                  }
                } else {
                  this.clearRebateSummaryDetail()
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.clearRebateSummaryDetail();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getRebateSummaryDailyFull: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.rebateSummaryDailyUrl();

        if (isSearch) this.currentPage1 = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.selectedOperatorID,
          start_date: this.dateRange1.startDate,
          end_date: this.dateRange1.endDate,
          rebate_type: this.rebate_type == "" ? null : this.rebate_type,
          sort_key: this.sortKey1,
          sort_type: this.sortType1,
          page_number: this.currentPage1,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.grandTotalListSummaryDetailFull = response.data.ds.grand_total;
                  this.rebateSummaryDetailFull = response.data.ds.list;
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
    },
    getRebateMember: function(isSearch) {
      let url = config.rebateMemberUrl();

      if (isSearch) this.currentPage2 = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.selectedOperatorID,
        start_date: this.dateRange2.startDate,
        end_date: this.dateRange2.endDate,
        rebate_type: this.rebate_type == "" ? null : this.rebate_type,
        sort_key: this.sortKey2,
        sort_type: this.sortType2,
        page_number: this.currentPage2,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.clearRebateMember()
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.ds.list.length > 0) {
                  this.showTotal = true

                  this.rebateMember = response.data.ds.list;
                  this.totalRow2 = this.rebateMember.length > 0 ? this.rebateMember[0].totalrows : 0;
                } else {
                  this.clearRebateMember()
                }
              } else {
                this.clearRebateMember()
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getRebateMemberFull: function(isSearch) {
      let url = config.rebateMemberUrl();

      if (isSearch) this.currentPage2 = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.selectedOperatorID,
        start_date: this.dateRange2.startDate,
        end_date: this.dateRange2.endDate,
        rebate_type: this.rebate_type == "" ? null : this.rebate_type,
        sort_key: this.sortKey2,
        sort_type: this.sortType2,
        page_number: this.currentPage2,
        page_size: -1
      };

      this.loading2 = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading2 = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.rebateMemberFull = response.data.ds.list;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading2 = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getRebateProvider(rebate_id) {
      this.clearRebateProvider()
      let url = config.rebateProviderUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        rebate_id: rebate_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.ds.list.length > 0) {
                  this.rebateProvider = response.data.ds.list;
                } else {
                  this.clearRebateProvider()
                }
              } else {
                this.clearRebateProvider()
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearRebateSummary() {
      this.showTotal = false
      this.totalRow = 0
      this.rebateSummary = []
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalActualRebate = 0
      this.grandTotallActualRebate = 0
      this.subTotallRoundedRebate = 0
      this.grandTotalRoundedRebate = 0
    },
    clearRebateSummaryDetail() {
      this.showTotal1 = false
      this.totalRow1 = 0
      this.rebateSummaryDetail = []
      this.subTotalTurnover1 = 0
      this.grandTotalTurnover1 = 0
      this.subTotalActualRebate1 = 0
      this.grandTotallActualRebate1 = 0
      this.subTotallRoundedRebate1 = 0
      this.grandTotalRoundedRebate1 = 0
    },
    clearRebateMember() {
      this.totalRow2 = 0;
      this.rebateMember = []
    },
    clearRebateProvider() {
      this.rebateProvider = []
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getRebateSummary(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getRebateSummary();
    },
    changedPageSize1: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage1 = 1;
      this.getRebateSummaryDaily(true);
    },
    changedPage1: function(pageNo) {
      this.currentPage1 = pageNo;
      this.getRebateSummaryDaily();
    },
    changedPageSize2: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage2 = 1;
      this.getRebateMember(true);
    },
    changedPage2: function(pageNo) {
      this.currentPage2 = pageNo;
      this.getRebateMember();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>